import "./index.css";
import React, { useState } from "react";
import { getYoutubeId } from "../../../../Utils/utils";

/**  TODO: In the future, this component should accept
 * videos from all types of sources and replace e.g.
 * the YoutubeInput component. For now, it only
 * accepts youtube urls.
 */
export default function VideoLinkInput({ onAddVideoLink, hex, white }) {
  const [input, setInput] = useState("");

  const handleChange = (e) => {
    setInput(e.target.value);
  };

  const isValidUrl = (url) => {
    // Basic URL validation logic
    return /^https?:\/\/(www\.)?youtube\.com\/watch\?v=/.test(url);
  };

  const isDisabled = !isValidUrl(input) || !getYoutubeId(input);

  return (
    <form className="video-link-input">
      {isValidUrl(input) && getYoutubeId(input) ? (
        <iframe
          className="video-link-input__iframe"
          title="video"
          width="100%"
          height="260"
          src={`//www.youtube.com/embed/${getYoutubeId(
            input
          )}?modestbranding=1&showinfo=0`}
          allowFullScreen
        />
      ) : (
        <div className="video-link-input__placeholder">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="1em"
            height="1em"
            viewBox="0 0 32 32"
            className="video-link-input__icon"
          >
            <path
              fill="currentColor"
              d="M20.31 6H4a2 2 0 0 0-2 2v16a3 3 0 0 0 0 .29zm9.15 2.11a1 1 0 0 0-1 .08L23 12.06v-1.62l7-7L28.56 2L2 28.56L3.44 30l4-4H21a2 2 0 0 0 2-2v-4.06l5.42 3.87A1 1 0 0 0 30 23V9a1 1 0 0 0-.54-.89"
            />
          </svg>
          <p className="video-player__text">No video available</p>
        </div>
      )}

      <label htmlFor="link" className="video-link-input__label">
        Youtube URL:
      </label>
      <div className="video-link-input__container">
        <input
          className="video-link-input__field form-control"
          type="url"
          id="link"
          aria-label="YouTube Video URL"
          value={input}
          onChange={handleChange}
          onKeyDown={(e) => e.key === "Enter" && onAddVideoLink(input)}
        />
        <button
          type="button"
          className="video-link-input__button btn btn-white btn-brand-hex"
          style={{
            "--hover-color": hex ? hex : "white",
            "--hover-text-color": white ? "white" : "black",
            backgroundColor: hex ? hex : "white",
            color: white ? "white" : "black",
          }}
          onClick={() => onAddVideoLink(input)}
          disabled={isDisabled}
        >
          Add video
        </button>
      </div>
    </form>
  );
}



// WEBPACK FOOTER //
// ./src/components/UploadPanel/components/VideoLinkInput/index.js